import React, { useState, useEffect } from 'react';
import { apiGetAllMappings, apiSaveMapping } from '../../api';

export default function MappingMaChamCong() {
    const [employees, setEmployees] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [loadingId, setLoadingId] = useState(null); // Trạng thái loading cho từng nút Lưu

    // Lấy dữ liệu toàn bộ NV từ EMPFILE (đã left join)
    const fetchEmployees = async () => {
        try {
            const res = await apiGetAllMappings();
            if (res.success) {
                // Thêm thuộc tính localMaCC để quản lý state nhập liệu trên từng dòng
                const dataWithLocalState = res.data.map(emp => ({
                    ...emp,
                    localMaCC: emp.MaChamCong || '' // Nếu null thì gán rỗng
                }));
                setEmployees(dataWithLocalState);
            }
        } catch (error) {
            console.error('Lỗi lấy danh sách:', error);
        }
    };

    useEffect(() => {
        fetchEmployees();
    }, []);

    // Xử lý thay đổi input trên từng dòng
    const handleInputChange = (maNhanVien, value) => {
        setEmployees(prev => prev.map(emp => 
            emp.MaNhanVien === maNhanVien ? { ...emp, localMaCC: value } : emp
        ));
    };

    // Xử lý Lưu cho từng nhân viên
    const handleSave = async (employee) => {
        if (!employee.localMaCC) {
            alert("Vui lòng nhập Mã chấm công trước khi lưu!");
            return;
        }

        setLoadingId(employee.MaNhanVien);
        try {
            const res = await apiSaveMapping({
                MaChamCong: parseInt(employee.localMaCC),
                MaNhanVien: employee.MaNhanVien
                // Không cần gửi HoTen nữa vì Backend đã tự lấy từ EMPFILE
            });

            if (res.success) {
                // Cập nhật lại state chính thức để đổi màu nút/hiển thị
                setEmployees(prev => prev.map(emp => 
                    emp.MaNhanVien === employee.MaNhanVien ? { ...emp, MaChamCong: employee.localMaCC } : emp
                ));
                alert(`Đã lưu mã ${employee.localMaCC} cho nhân viên ${employee.HoTen}!`);
            }
        } catch (error) {
            alert('Lỗi khi lưu: ' + error.message);
        } finally {
            setLoadingId(null);
        }
    };

    // Lọc theo thanh tìm kiếm
    const filteredEmployees = employees.filter(row => {
        const search = searchTerm.toLowerCase();
        return (
            (row.MaChamCong && row.MaChamCong.toString().toLowerCase().includes(search)) ||
            (row.MaNhanVien && row.MaNhanVien.toLowerCase().includes(search)) ||
            (row.HoTen && row.HoTen.toLowerCase().includes(search))
        );
    });

    return (
        <div className="p-4 sm:p-6 bg-white rounded-2xl">
            <div className="mb-6 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                <h2 className="text-xl font-bold text-[#102a43]">Cấp Nhật Mã Chấm Công Nhân Viên</h2>
            </div>

            {/* THANH TÌM KIẾM */}
            <div className="mb-6">
                <div className="relative max-w-md">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <svg className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor"><path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" /></svg>
                    </div>
                    <input
                        type="text"
                        className="block w-full pl-10 pr-3 py-2.5 border border-gray-300 rounded-xl leading-5 bg-gray-50 focus:bg-white focus:outline-none focus:ring-2 focus:ring-[#147d64]/50 transition duration-150"
                        placeholder="Tìm theo Mã CC, Mã NV hoặc Tên..."
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>
            </div>

            {/* BẢNG HIỂN THỊ & NHẬP LIỆU TRỰC TIẾP */}
            <div className="overflow-x-auto rounded-xl border border-gray-200 shadow-sm">
                <table className="min-w-full text-left bg-white">
                    <thead className="bg-[#f8fafc] text-xs uppercase tracking-wider text-slate-600 font-bold border-b border-gray-200">
                        <tr>
                            <th className="p-4 w-16 text-center">STT</th>
                            <th className="p-4">Mã Nhân Viên (Hệ thống)</th>
                            <th className="p-4">Họ và Tên</th>
                            <th className="p-4">Mã Chấm Công (Máy ZKTeco)</th>
                            <th className="p-4 text-center">Thao tác</th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100">
                        {filteredEmployees.length > 0 ? (
                            filteredEmployees.map((row, index) => {
                                // Kiểm tra xem giá trị nhập vào đã khác với DB chưa để đổi màu nút Lưu
                                const isChanged = row.localMaCC.toString() !== (row.MaChamCong?.toString() || '');

                                return (
                                    <tr key={row.MaNhanVien} className="hover:bg-slate-50 transition-colors">
                                        <td className="p-4 text-sm text-center text-gray-500">{index + 1}</td>
                                        <td className="p-4 text-sm font-semibold text-slate-800">{row.MaNhanVien}</td>
                                        <td className="p-4 text-sm text-slate-700">{row.HoTen}</td>
                                        <td className="p-4 text-sm">
                                            <input 
                                                type="number" 
                                                className={`w-32 p-2 border rounded-md outline-none focus:ring-2 focus:ring-[#147d64]/50 ${
                                                    row.MaChamCong ? 'border-green-300 bg-green-50' : 'border-gray-300 bg-white'
                                                }`}
                                                placeholder="Nhập mã..."
                                                value={row.localMaCC}
                                                onChange={(e) => handleInputChange(row.MaNhanVien, e.target.value)}
                                            />
                                        </td>
                                        <td className="p-4 text-sm text-center">
                                            <button 
                                                onClick={() => handleSave(row)}
                                                disabled={loadingId === row.MaNhanVien || !isChanged}
                                                className={`px-4 py-1.5 rounded-md font-bold transition-all ${
                                                    isChanged
                                                    ? 'bg-[#147d64] text-white hover:bg-[#0f604d] shadow-sm' // Nổi bật khi có thay đổi
                                                    : 'bg-gray-200 text-gray-400 cursor-not-allowed' // Mờ đi khi chưa nhập/chưa đổi
                                                }`}
                                            >
                                                {loadingId === row.MaNhanVien ? 'Đang lưu...' : (row.MaChamCong ? 'Cập nhật' : 'Lưu')}
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="5" className="p-8 text-center text-gray-500">
                                    Không tìm thấy nhân viên nào.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}